import { fork, takeLatest } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------

/* eslint-disable no-console */
import { put, call, cancelled } from 'redux-saga/effects';
import notify from '../../lib/notifiy';
import actionConstants from '../constants';
import { COMMON_ERROR_CODES } from '../../lib/constants';
import store from '../store';
// ------------------------------------
// Common Worker Saga
// ------------------------------------

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function* downloadZipSaga(action) {
  const {
    serviceMethod,
    actionTypeFailure,
    actionTypeRequest,
    extra,
    callback,
    genericErrorHandling = true,
    hideLoader,
  } = action.payload;
  let loaderStarted = false;
  let loaderStopped = false;
  try {
    yield put({
      type: actionTypeRequest,
      payload: extra,
    });
    if (!hideLoader) {
      yield put({
        type: actionConstants.START_LOADER,
        payload: { actionType: actionTypeRequest },
      });
      loaderStarted = true;
    }

    const apiResponse = yield call(serviceMethod);
    const zipURL = window.URL.createObjectURL(new Blob([apiResponse.body], {type: 'application/zip'}));
    const tempLink = document.createElement('a');
    tempLink.href = zipURL;
    tempLink.download = extra?.fileName || (apiResponse?.headers['content-disposition']?.split('filename=')[1] ?? 'file.zip');
    document.body.appendChild(tempLink);
    tempLink.click();
    tempLink.remove();

    if (!hideLoader) {
      yield put({
        type: actionConstants.STOP_LOADER,
        payload: { actionType: actionTypeRequest },
      });
      loaderStopped = true;
    }

    if (callback) callback();
  } catch (error: any) {
    if (loaderStarted && !loaderStopped) {
      yield put({
        type: actionConstants.STOP_LOADER,
        payload: { actionType: actionTypeRequest },
      });
      loaderStopped = true;
    }
    if (error && error.response && error.response.body) {
      yield put({
        type: actionTypeFailure,
        payload: { body: error.response.body, extra },
      });
      // Common Generic Error Handling
      if (
        COMMON_ERROR_CODES[error.response.body.error_code] &&
        genericErrorHandling
      ) {
        notify({
          // description: store.getState().validationErrors.SOMETHING_WENT_WRONG,
          type: 'error',
          message:
            store.getState().validationReducer.validationErrorState
              .validationErrors.SOMETHING_WENT_WRONG ||
            'Something went wrong! Please try again.',
          description: '',
        });
      }
    } else {
      notify({
        description:
          store.getState().validationReducer.validationErrorState
            .validationErrors.SOMETHING_WENT_WRONG ||
          'Something went wrong! Please try again.',
        duration: 1,
        type: 'error',
        message: 'Error',
      });
      console.error(error);
    }
  } finally {
    if (loaderStarted && !loaderStopped && (yield cancelled())) {
      yield put({
        type: actionConstants.STOP_LOADER,
        payload: { actionType: actionTypeRequest },
      });
    }
  }
}


export default function* settlementsWatcher(): Generator<any, void, unknown> {
  yield takeLatest(ActionConstants.GET_SETTLEMENT_DATA, workerSaga);
  yield takeLatest(ActionConstants.GET_EDGE_SETTLEMENT_DATA, workerSaga);
  yield takeLatest(ActionConstants.GET_SETTLEMENT_DETAIL_SUMMARY, workerSaga);
  yield takeLatest(ActionConstants.GET_SETTLEMENT_DOWNLOAD, downloadZipSaga);
  yield takeLatest(ActionConstants.GET_SETTLEMENTS_OVERVIEW_DATA, workerSaga);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_SETTLEMENT_DETAIL_SUMMARY
  );
  yield takeLatest(ActionConstants.GET_EDGE_MPR_LIST, workerSaga);
  yield takeLatest(ActionConstants.GET_SYNC_NOW, workerSaga);
  yield takeLatest(ActionConstants.GET_PG_LIST, workerSaga);
  yield takeLatest(ActionConstants.GET_SETTLEMENT_STATUS_LIST, workerSaga);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_SETTLEMENT_OVERVIEW_DATA
  );
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_EDGE_SETTLEMENT_LIST);
  yield fork(takeLatestUntilApiCancel, ActionConstants.SETTLEMENTS_SEARCH);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_LIST
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_SETTLEMENT_MPR_FILE_LOCATION
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_SETTLEMENT_MPR_RECOVERY
  );
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_DEDUCTION_DETAILS);
  yield takeLatest(ActionConstants.GET_ONDEMAND_SETTLEMENT, workerSaga);
  yield takeLatest(ActionConstants.MERCHANT_ODS_DATA, workerSaga);
  yield takeLatest(ActionConstants.POST_ONDEMAND_SETTLEMENT, workerSaga);
  yield takeLatest(
    ActionConstants.GET_ONDEMAND_SETTLEMENT_STATUS,
    workerSaga
  );


  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_ONDEMAND_SETTLEMENT_HISTORY_DATA
  );

  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_PENDING_SETTLEMENTS_LIST);

}
